<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-03-15 10:34:38
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-09-18 13:41:45
 * @FilePath: /wemeet-admin-new/src/views/dragger/template/tpl_text_picture.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="layout">
    <div class="view-height-200">
      <img
        v-if="!res.list[0].extraParams || !res.list[0].extraParams.isVideo"
        alt
        class="image-mode"
        :src="res.list[0].img"
      />
      <video v-else controls :src="res.list[0].extraParams.videoSrc" style="width: 100%; height: 100%"></video>
    </div>
    <div class="view-height-200">
      <img
        v-if="!res.list[1].extraParams || !res.list[1].extraParams.isVideo"
        alt
        class="image-mode"
        :src="res.list[1].img"
      />
      <video v-else controls :src="res.list[1].extraParams.videoSrc" style="width: 100%; height: 100%"></video>
    </div>
  </div>
</template>

<script>
  export default {
    title: '文字图片模板',
    props: ['res'],
  }
</script>
<style lang="scss" scoped>
  @import './tpl.scss';
</style>
